"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var omit = require("lodash.omit");
var Radium = require("radium");
var react_1 = require("react");
var components_1 = require("components");
var LayoutBody_1 = require("./LayoutBody");
var componentStyle = {
    base: {
        display: 'flex',
        width: '100%',
        backgroundColor: '#ececec',
        boxSizing: 'border-box',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden',
    },
};
var getStyle = function (style, props) { return ([
    style.base,
    props.style,
]); };
var Layout = (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            drawerOpen: false,
        };
        return _this;
    }
    Layout.prototype.render = function () {
        var _a = omit(this.props, ['style']), title = _a.title, drawerItems = _a.drawerItems, children = _a.children, otherProps = __rest(_a, ["title", "drawerItems", "children"]);
        var drawerOpen = this.state.drawerOpen;
        return (React.createElement("div", __assign({ style: getStyle(componentStyle, this.props) }, otherProps),
            React.createElement(components_1.AppBar, { title: title, onToggleDrawerClick: this.toggleDrawer.bind(this) }),
            React.createElement(LayoutBody_1.LayoutBody, { drawerItems: drawerItems, drawerOpen: drawerOpen }, children)));
    };
    Layout.prototype.toggleDrawer = function () {
        this.setState({ drawerOpen: !this.state.drawerOpen });
    };
    Layout.defaultProps = {
        drawerItems: null,
        title: '',
    };
    Layout = __decorate([
        Radium,
        __metadata("design:paramtypes", [Object])
    ], Layout);
    return Layout;
}(react_1.PureComponent));
exports.Layout = Layout;



//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.tsx
// module id = 314
// module chunks = 0